"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFlightData = exports.getTimezoneNumberFromFlightField = void 0;
exports.getAirportTimezone = getAirportTimezone;
exports.getAirportTimezoneEnum = getAirportTimezoneEnum;
const date_1 = require("../date/date");
const eventr_interface_1 = require("../interfaces/eventr.interface");
const airportsObjs_1 = require("./airportsObjs");
/**
 * Given airport id (LHR) will return the tz name for that airport or undifined
 */
function getAirportTimezone(airportId) {
    const searchString = airportId.toUpperCase();
    const airport = airportsObjs_1.airports.find((airportVal) => {
        return airportVal.id === searchString;
    });
    if (!airport || !airport.obj.timezone) {
        return undefined;
    }
    return airport.obj.timezone;
}
/**
 * Given airport id (LHR) will return the tz enum number for that airport or undifined
 */
function getAirportTimezoneEnum(airportId) {
    const searchString = airportId.toUpperCase();
    const airport = airportsObjs_1.airports.find((airportVal) => {
        return airportVal.id === searchString;
    });
    if (!airport || !airport.obj.timezone) {
        return undefined;
    }
    return (0, eventr_interface_1.getTimezoneNumber)(airport.obj.timezone);
}
const getTimezoneNumberFromFlightField = (field, newFlight) => {
    switch (field) {
        case 'dep_time':
        case 'dep_estimated':
            return newFlight.outboundAirportAbr
                ? getAirportTimezoneEnum(newFlight.outboundAirportAbr)
                : 336;
        case 'arr_time':
        case 'arr_estimated':
            return newFlight.inboundAirportAbr
                ? getAirportTimezoneEnum(newFlight.inboundAirportAbr)
                : 336;
        default:
            return 336;
    }
};
exports.getTimezoneNumberFromFlightField = getTimezoneNumberFromFlightField;
const updateFlightData = (flight, newFlight) => {
    for (const [key, value] of Object.entries(newFlight)) {
        if (typeof value === 'object' && value !== null) {
            for (const [key2, value2] of Object.entries(value)) {
                if (isTimeField(key2)) {
                    const timezoneNumber = (0, exports.getTimezoneNumberFromFlightField)(key2, newFlight);
                    const newEventrDate = new date_1.EventrDate(value2.replace(' ', 'T'));
                    newEventrDate.setTimezoneEnum(timezoneNumber, false);
                    flight[key][key2] = newEventrDate.dateTimeString;
                }
                else {
                    if (isValidValue(value2)) {
                        flight[key][key2] = value2;
                    }
                }
            }
        }
        else {
            if (isValidValue(value)) {
                if (key === 'status') {
                    flight['flightStatus'] = value;
                }
                else {
                    flight[key] = value;
                }
            }
        }
    }
    flight['departure_airport'] = airportsObjs_1.airports.find((option) => option.id === flight.outboundAirportAbr);
    flight['arrival_airport'] = airportsObjs_1.airports.find((option) => option.id === flight.inboundAirportAbr);
    if (flight.departure.dep_time) {
        flight.flightDate = flight.departure.dep_time;
        const x = new date_1.EventrDate(flight.departure.dep_time);
        x.subtract({ hours: 2 });
        flight.check_in = x.dateTimeString;
    }
};
exports.updateFlightData = updateFlightData;
const isValidValue = (value) => value !== undefined &&
    (typeof value !== 'string' || value.toLowerCase() !== 'null');
const isTimeField = (field) => [
    'dep_time',
    'arr_time',
    'arr_estimated',
    'dep_estimated',
    'dep_time_utc',
    'arr_time_utc',
    'arr_estimated_utc',
    'dep_estimated_utc',
].includes(field);
